// The default app tab of the PWA
export var PWA_DEFAULT_TAB='main';